/* Arrow nav for .ax-hscroll rows. Delegated so any number of row sections share one
   listener; the guard keeps duplicate per-section script tags from double-binding.
   Steps two cards at a time; the target is quantised to the card step so it never
   drifts off-snap; snapping is suspended during the programmatic scroll because
   proximity snapping fights smooth scrollTo in Safari. Gap is read from computed
   style (the reference implementation hard-coded it and drifted when CSS changed). */
(function () {
  if (window.axHomeRows) return;
  window.axHomeRows = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ax-scrollnav button');
    if (!btn) return;
    var row = document.getElementById(btn.getAttribute('data-scroll'));
    if (!row) return;
    var card = row.firstElementChild;
    var gap = parseFloat(getComputedStyle(row).columnGap) || 14;
    var step = card ? card.getBoundingClientRect().width + gap : 300;
    var dir = Number(btn.getAttribute('data-dir')) || 1;
    var target = Math.round((row.scrollLeft + dir * step * 2) / step) * step;
    target = Math.max(0, Math.min(target, row.scrollWidth - row.clientWidth));
    row.style.scrollSnapType = 'none';
    row.scrollTo({ left: target, behavior: 'smooth' });
    clearTimeout(row._axSnapTimer);
    row._axSnapTimer = setTimeout(function () { row.style.scrollSnapType = ''; }, 600);
  });
})();
